import { render, staticRenderFns } from "./tenuta-dell-ornellaia.vue?vue&type=template&id=2901ed74&scoped=true"
import script from "./tenuta-dell-ornellaia.vue?vue&type=script&lang=js"
export * from "./tenuta-dell-ornellaia.vue?vue&type=script&lang=js"
import style0 from "./tenuta-dell-ornellaia.vue?vue&type=style&index=0&id=2901ed74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901ed74",
  null
  
)

export default component.exports